<template>
	<section role="navigation" id="global-header">
		<div class="container-sm is-centered">
			<h1><router-link to="/">Blake Lipson</router-link></h1>
			<h2>Front End Web Developer</h2>
			<p>To see what I've been working on, check out the projects below.</p>
			<nav id="global-nav">
				<router-link to="/projects">Projects</router-link>
				<router-link to="/about">About</router-link>
			</nav>
		</div>
	</section>
</template>

<script>
export default {
	name: 'GlobalHeader'
}
</script>

<style lang="scss">
@import 'src/assets/css/modules/colors';

#global-header {
	padding: 4rem 0 2rem;
	text-align: center;
	h1 {
		color: $navy;
		font-size: 2rem;
		font-weight: 500;
		margin: 0;
	}
	h2 {
		color: #333;
		font-size: 1rem;
		font-style: italic;
		font-weight: 400;
		margin: 0.75rem 0 0;
	}
}

#global-nav {
	margin-top: 3rem;
	font-size: 2rem;
	a {
		margin: 0 0.75rem;
		&:hover, &:focus, &.router-link-active {
			border-bottom: 2px solid currentColor;
		}
		&.router-link-active {
			color: $teal;
		}
	}
}
</style>